import { Mascot } from '@/components/shared'
import { Button } from '@/components/ui/button'
import { useOrganizationStore } from '@/store/organization.store'
import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  const organization = useOrganizationStore(state => state.currentOrganization)
  return (
    <div className="flex-1 overflow-auto">
      <div className="flex min-h-[calc(100vh-3.5rem)] flex-col items-center justify-center bg-background p-4 text-foreground">
        <div className="text-center">
          <Mascot variant="not-found" size="lg" className="mb-8" />
          <h1 className="mb-4 text-4xl font-bold text-foreground">404</h1>
          <p className="mb-6 text-muted-foreground">Page not found</p>
          <Link to={organization?.slug ? `/${organization.slug}` : '/'}>
            <Button>Return to Dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
